import AppointmentBookWizard from "../AppointmentBookWizard";

export default function AdminDoctorBookSlot({
  open,
  onClose,
  doctorId,
  branchId,
  date,
  specializationId,
  onBooked,
}) {
  return (
    <AppointmentBookWizard
      open={open}
      onClose={onClose}
      onBooked={onBooked}
      title={date ? `Новая запись · ${date}` : "Новая запись"}
      doctorId={doctorId}
      branchId={branchId}
      specializationId={specializationId}
      initialDate={date}
    />
  );
}
